import clsx from "clsx";

export const TransactionBadge = ({ staus }) => {
  return (
    <p
      className={clsx(
        staus === "success"
          ? "bg-[#C8FFE8] text-[#41A777]"
          : staus === "pending"
          ? "bg-[#FFEBBA] text-[#DFB035]"
          : "bg-[#FFD9D9] text-[#FF8383]",
        "px-1.5 py-[3px] rounded-[4px] text-[9px] leading-none text-center w-fit float-end"
      )}
    >
      <span> {staus}</span>
    </p>
  );
};
